import { AnimatePresence, motion, useCycle } from "framer-motion"
import Image from "next/image"
import Router, { useRouter } from "next/router"
import React, { useContext, useEffect, useState } from "react"
import { isMobileContext } from "../../contexts/isMobileContext"
import Button from "./Button"
import MobileMenu from "./MobileMenu"
import MobileSearchMenu from "./MobileSearchMenu"
import { useTranslation } from "next-i18next"
import { nextRouteContext } from "../../contexts/nextRouteContext"
import { phaseColorContext } from "../../contexts/phaseColorContext"
import DropDownMenu from "./DropDownMenu"
import { subMenuAnimate } from "../../utils/Animations"
import { isMenuOpendContext } from "../../contexts/isMenuOpendContext"
import ArrowsSpliting from "../Animations/ArrowsSpliting"
import BookingMenu from "./BookingMenu"
import { BASE_URL } from "@/utils/FetchData"
const SeaShoreNav = ({ logos }) => {
	const { phaseColor } = useContext(phaseColorContext)
	const { t } = useTranslation("common")
	const { locale, asPath } = useRouter()
	const { isMobile } = useContext(isMobileContext)
	const {
		setIsMenuOpenedContext,
		searchMenuOpened,
		isMenuOpenedContext,
		isDevelopMenuOpened,
		setIsDevelopMenuOpened,
		isBookingMenuOpened,
		setIsBookingMenuOpened,
		isMenuOpened,
	} = useContext(isMenuOpendContext)
	const { setNextRoute } = useContext(nextRouteContext)
	const [isHover, toggleHover] = useState(false)
	const toggleMobileMenuOpen = () => {
		document.body.classList.toggle("no-scroll")
		setIsMenuOpenedContext(!isMenuOpenedContext)
	}
	useEffect(() => {
		if (isMenuOpenedContext || isBookingMenuOpened) {
			document.body.classList.add("no-scroll")
		} else {
			document.body.classList.remove("no-scroll")
		}
	}, [isMenuOpenedContext, isBookingMenuOpened])
	useEffect(() => {
		if (searchMenuOpened || isBookingMenuOpened) {
			setIsMenuOpenedContext(false)
		}
	}, [searchMenuOpened, isBookingMenuOpened])

	return (
		<>
			<div className={`mainnav-container ${isMenuOpenedContext && "open-nav"}`}>
				<div
					onClick={() => {
						setNextRoute(t("navbar.home"))
						Router.push("/")
					}}
				>
					<div className="logo-container">
						<Image
							src={
							logos?.logo_one?.data?.attributes?.url
									? BASE_URL + logos?.logo_one?.data?.attributes?.url
									: "/icons/newLogo.png"
							}
							alt="logo"
							objectFit="contain"
							layout="fill"
							priority
						/>
					</div>
				</div>
				<div
					className="logo"
					onClick={() => setIsBookingMenuOpened(true)}
				>
					<div className="logo-container">
						<Image
							src={
							logos?.logo_two?.data?.attributes?.url
									? BASE_URL + logos?.logo_two?.data?.attributes?.url
									: "/icons/newLogo.png"
							}
							alt="logo"
							objectFit="contain"
							layout="fill"
							priority
						/>
					</div>
				</div>
			</div>
		</>
	)
}

export default SeaShoreNav
